document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (!event.target.matches('.footer-mobile-toggle')) return;
    event.target.classList.toggle('opened');
  });
});